import { Cart, LineItem } from 'shared/types/cart';
import { cartLabelBrands } from '@/helpers/utils/brandname';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

export const isPersonalizedItem = (lineItem: LineItem): boolean => {
  return !!(lineItem?.variant?.attributes?.personalizeOption && lineItem?.personalizeProductId);
};

export const getPersonalizedText = (lineItem: LineItem): string => {
  let personalizetext = lineItem?.personalizeText ?? '';
  const result: string[] = [];

  const extractTextValues = (items?: any[]): void => {
    items?.forEach((item) => {
      if (item?.text) {
        result.push(item?.text);
      }
    });
  };

  const extractSideValues = (side: any): void => {
    side?.text && extractTextValues(side?.text);
    side?.circletext && extractTextValues(side?.circletext);
  };

  try {
    const personalizeJson = JSON.parse(personalizetext);
    if (personalizeJson) {
      personalizeJson?.Front && extractSideValues(personalizeJson?.Front);
      personalizeJson?.Back && extractSideValues(personalizeJson?.Back);
      personalizeJson?.FRONT && extractSideValues(personalizeJson?.FRONT);
      personalizeJson?.BACK && extractSideValues(personalizeJson?.BACK);
      personalizetext = result?.join(', ');
    }
  } catch (error) {}
  return personalizetext;
};

export const updatedUrlRefine = (str: string) => {
  const lastSlashIndex = str.lastIndexOf('/');
  const lastDashIndex = str.lastIndexOf('-');
  if (lastSlashIndex !== -1) {
    const lastParam = str.substring(lastSlashIndex, str.length);
    if (lastParam.split('-').length > 2) {
      return str.substring(0, lastDashIndex);
    } else {
      return str;
    }
  }
};

export const getCartLabel = (siteId: string) => {
  let cartLabel = mapLocaleToMeaningfulFormat().shoppingBag;
  if (cartLabelBrands.includes(siteId)) {
    cartLabel = mapLocaleToMeaningfulFormat().cart;
  }
  return cartLabel;
};

export const isExpShippingAvailable = (lineItems: LineItem[] | undefined) => {
  if (!lineItems || lineItems?.length === 0) return true;
  const expShipAvailable: any = lineItems?.filter(
    (lineItem) =>
      !lineItem?.lineGroupId && !lineItem.isInsuranceItem && lineItem?.variant?.attributes?.expressShipAvail,
  );
  if (expShipAvailable?.length === 0) {
    return false;
  }
  return true;
};

export const isPriorityShippingAvailable = (lineItems: LineItem[] | undefined) => {
  if (!lineItems || lineItems?.length === 0) return true;
  const priorityShipAvailable: any = lineItems?.filter(
    (lineItem) =>
      !lineItem?.lineGroupId && !lineItem.isInsuranceItem && lineItem?.variant?.attributes?.priorityShipAvail,
  );
  if (priorityShipAvailable?.length === 0) {
    return false;
  }
  return true;
};

export const getInsuranceItemId = (cart: Cart) => {
  return cart?.lineItems?.find((item: LineItem) => item?.isInsuranceItem)?.lineItemId;
};

export const cartHasMultipleInsuranceItems = (cart: Cart) => {
  return (cart?.lineItems?.filter((lineItem) => lineItem?.isInsuranceItem)?.length ?? 0) > 1;
};
